<template>
  <div class="space-y-2">
    <div>
      <h5 class="text-sm font-medium tracking-wide text-gray-700 mb-2">Url</h5>
      <input
        v-select
        v-model="syncUrl"
        class="px-4 py-2 leading-5 text-sm border rounded hover:border-gray-700 focus:outline-none focus:border-gray-700 focus:ring ring-blue-500 ring-opacity-50 w-full"
      />
    </div>
    <div>
      <h5 class="text-sm font-medium tracking-wide text-gray-700 mb-2">Title (optional)</h5>
      <input
        v-model="syncTitle"
        class="px-4 py-2 leading-5 text-sm border rounded hover:border-gray-700 focus:outline-none focus:border-gray-700 focus:ring ring-blue-500 ring-opacity-50 w-full"
      />
    </div>
    <div>
      <h5 class="text-sm font-medium tracking-wide text-gray-700 mb-2">Description (optional)</h5>
      <textarea
        v-model="syncDescription"
        rows="5"
        class="px-4 py-2 leading-5 text-sm border rounded hover:border-gray-700 focus:outline-none focus:border-gray-700 focus:ring ring-blue-500 ring-opacity-50 w-full resize-none"
      />
    </div>
    <div class="space-x-2">
      <button
        type="button"
        class="px-4 py-2 leading-4 text-xs rounded bg-green-600 border border-transparent text-white hover:bg-green-500 focus:border-green-700 focus:outline-none focus:ring ring-green-500 ring-opacity-50 disabled:bg-gray-600"
        :disabled="!syncUrl"
        @click="update"
      >
        Update
      </button>
      <button
        type="button"
        class="px-4 py-2 leading-4 text-xs rounded bg-transparent border border-transparent text-gray-700 hover:bg-gray-300 hover:text-gray-900 focus:border-gray-500 focus:outline-none focus:bg-gray-300"
        @click="cancel"
      >
        Cancel
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LinkEditor',

  props: {
    url: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },

  methods: {
    update() {
      if (!this.syncUrl) {
        return;
      }

      this.$emit('update');
    },

    cancel() {
      this.$emit('cancel');
    },
  },

  computed: {
    syncUrl: {
      get() {
        return this.url;
      },
      set(value) {
        return this.$emit('update:url', value);
      },
    },
    syncTitle: {
      get() {
        return this.title;
      },
      set(value) {
        return this.$emit('update:title', value);
      },
    },
    syncDescription: {
      get() {
        return this.description;
      },
      set(value) {
        return this.$emit('update:description', value);
      },
    },
  },
};
</script>
